import { TableCell, Button } from '@mui/material';
import { EditIcon } from 'assets/icons';
import HistoryIcon from '@mui/icons-material/History';
import React, { FC } from 'react';
import { ICON_ACTION_COLUMN_WIDTH } from 'utils/constants';
import { EditIconDisable } from 'assets/icons/edit-icon-disable';

interface Props {
    type: 'edit' | 'revert';
    index: number;
    disabled?: boolean;
    onTapped: () => void;
}

const TableIcon: FC<Props> = (props: Props) => {
    const { index, disabled, onTapped, type = 'edit' } = props;

    return (
        <TableCell
            sx={{
                width: ICON_ACTION_COLUMN_WIDTH,
                position: 'sticky',
                right: 0,
                backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 1,
                    width: 2,
                    height: '100%',
                    background: 'linear-gradient(to right, rgba(0, 0, 0, 0.2), transparent)',
                },
            }}>
            <Button
                disabled={disabled}
                onClick={onTapped}
                aria-label={type === 'edit' ? 'Edit' : 'History'}>
                {type === 'edit' ? (
                    disabled ? (
                        <EditIconDisable />
                    ) : (
                        <EditIcon />
                    )
                ) : (
                    <HistoryIcon sx={{ color: 'red', width: 25, height: 25 }} />
                )}
            </Button>
        </TableCell>
    );
};

export default TableIcon;
